import React, { Fragment } from 'react'
import './MainTityleStyle.css'

const MainTitle = ({title, subTitleLine, className}) => {
  return (
    <Fragment>
       <div className={className}>     
            <h2>{title}</h2>
            <p>{subTitleLine}</p>
            </div>
    </Fragment>
  )
}

export default MainTitle
